<template>
  <div class="main">
    <div id="container" class="mymap"></div>
    <div class="realLeft">
      <div class="oldBox">
        <div class="leftTitle">站点等级占比</div>
        <div id="currentSituation"></div>
      </div>
      <div class="oldBox">
        <div class="leftTitle">建筑面积</div>
        <div id="currentBulidingArea"></div>
      </div>
      <div class="oldBox">
        <div class="leftTitle">工作人员数</div>
        <div id="bedNums"></div>
      </div>
    </div>
    <div class="realRight">
      <div class="oldBox" style="height: 12vh">
        <div class="leftTitle">房屋性质</div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-around;
            height: 16vh;
          "
        >
          <div class="housexz">
            <el-progress
              :text-inside="true"
              :stroke-width="24"
              :percentage="100"
              status="success"
            ></el-progress>
            <span style="color: #fff">服务用房</span>
          </div>
          <div class="housexz">
            <el-progress
              :text-inside="true"
              :stroke-width="20"
              :percentage="0"
              status="exception"
            ></el-progress>
            <span style="color: #fff">其他</span>
          </div>
        </div>
      </div>
      <div style="display: flex">
        <div class="oldBox" style="flex: 1; height: 30vh">
          <div class="leftTitle">活动总数</div>
          <div style="position: relative; text-align: center; margin-top: 32px">
            <img style="width: 210px" src="./assets/big/hz.png" alt="" />
            <div
              style="
                text-align: center;
                position: absolute;
                top: 38%;
                left: 44%;
              "
            >
              <p style="font-weight: blod; font-size: 18px; color: #fff">
                {{ alltotal }}
              </p>
              <p class="smallt" style="font-size: 12px">活动总数</p>
            </div>
          </div>
          <div class="newSty">
            <span style="25px;">志愿</span
            ><el-progress
              color="#D800FF"
              :show-text="false"
              :format="format"
              :stroke-width="10"
              :percentage="label1"
            ></el-progress
            ><span>{{ label1 }}%</span>
          </div>
          <div class="newSty">
            <span style="25px;">养生</span
            ><el-progress
              color="#7FD42D"
              :show-text="false"
              :format="format"
              :stroke-width="10"
              :percentage="label2"
            ></el-progress
            ><span>{{ label2 }}%</span>
          </div>
          <div class="newSty">
            <span style="25px;">健身</span
            ><el-progress
              color="#F21B62"
              :show-text="false"
              :format="format"
              :stroke-width="10"
              :percentage="label3"
            ></el-progress
            ><span>{{ label3 }}%</span>
          </div>
          <div class="newSty">
            <span style="25px;">法律</span
            ><el-progress
              color="#0F5BF5"
              :show-text="false"
              :format="format"
              :stroke-width="10"
              :percentage="label4"
            ></el-progress
            ><span>{{ label4 }}%</span>
          </div>
          <div class="newSty">
            <span style="25px;">其他</span
            ><el-progress
              color="#50b7c1"
              :show-text="false"
              :format="format"
              :stroke-width="10"
              :percentage="label5"
            ></el-progress
            ><span>{{ label5 }}%</span>
          </div>
        </div>
        <div class="oldBox" style="flex: 1; height: 30vh; margin-left: 20px">
          <div class="leftTitle">参与</div>
          <div id="olderJoin"></div>
        </div>
      </div>
      <div class="oldBox" style="height: 35vh; padding: 25px 0 0 10px">
        <div class="leftTitle">活动集锦</div>

        <div style="display: flex">
          <div class="activeList">
            <div class="ac-title" style="display: flex">
              <div style="width: 50px">序号</div>
              <!-- <div style="flex: 1">活动类型</div> -->
              <div style="flex: 1">活动名称</div>
            </div>
            <div class="houseContent" style="height: 300px; overflow: scroll">
              <!-- <vue-seamless-scroll
                :style="{
                  height: this.scrollHeight + 'px',
                }"
                :data="activesList"
                :class-option="defaultOption"
                class="warp-content"
              > -->
              <div
                class="ac-item"
                style="display: flex"
                v-for="(item, index) in activesList"
                :key="index"
                @click="showInfo(item.id)"
              >
                <div style="width: 50px">{{ index + 1 }}</div>
                <!-- <div
                    style="
                      flex: 1;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    <span v-if="item.type == 1">图文</span>
                    <span v-if="item.type == 2">视频</span>
                  </div> -->
                <div style="flex: 1">{{ item.name }}</div>
              </div>
              <!-- </vue-seamless-scroll> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 站点信息弹窗 -->
    <div class="perInfoBox2" v-if="showJiJinInfo2">
      <div class="info-txt2">
        <div class="info-item2">
          <p class="intitle2" style="margin-bottom: 15px; background: #162a5b">
            站点信息详情
          </p>
          <p>基本信息</p>
          <div style="width: 100%; height: 200px; background: #162a5b">
            <div
              style="
                width: 160px;
                height: 160px;
                margin: 20px 20px 0 0;
                float: right;
              "
            >
              <img class="defaultImg" src="./assets/big/default.jpg" alt="" />
            </div>
            <div>
              <div style="padding: 10px; width: 500px; color: #85c2ff">
                <span
                  ><label for="">站点名称：</label>{{ info.stationName }}</span
                >
                <p style="margin-top: 10px">
                  <label for="">联系人：</label>{{ info.concatNam }}
                </p>
                <p style="margin-top: 10px">
                  <label for="">联系方式：</label>{{ info.phone }}
                </p>

                <p style="margin-top: 10px">
                  <label for="">地址：</label>{{ info.stationAddress }}
                </p>
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-around;
                height: 233px;
                margin-top: 33px;
              "
            >
              <div style="width: 100%">
                <p style="text-align: center">活动锦集</p>
                <div style="height: 199px; background: #162a5b"></div>
              </div>
            </div>
          </div>
        </div>
        <span class="close-info2" @click="showJiJinInfo2 = false">×</span>
      </div>
    </div>
    <!-- 服务人员信息 -->
    <div class="perInfoBox2" v-if="showJiJinInfo1">
      <div class="info-txt2">
        <div class="info-item2">
          <p class="intitle2" style="margin-bottom: 15px; background: #162a5b">
            服务人员详情
          </p>
          <p>基本信息</p>
          <div style="width: 100%; height: 300px; background: #162a5b">
            <div
              style="
                width: 160px;
                height: 300px;
                margin: 20px 20px 0 0;
                float: right;
              "
            >
              <img
                class="defaultImg"
                v-if="pInfo.personSex == 1"
                src="./assets/big/boy.png"
                alt=""
              />
              <img
                class="defaultImg"
                v-else
                src="./assets/big/girl.png"
                alt=""
              />
            </div>
            <!-- <div> -->
            <div style="padding: 10px; width: 500px; color: #85c2ff">
              <span><label for="">姓名：</label>{{ pInfo.personName }}</span>
              <p style="margin-top: 10px">
                <label for="">联系方式：</label>{{ pInfo.personPhone }}
              </p>
              <p style="margin-top: 10px">
                <label for="">性别：</label
                >{{ pInfo.personSex == 1 ? "男" : "女" }}
              </p>
              <p style="margin-top: 10px">
                <label for="">年龄：</label>{{ pInfo.personAge }}
              </p>
              <p style="margin-top: 10px">
                <label for="">地址：</label>{{ pInfo.address }}
              </p>
            </div>
            <!-- </div> -->
          </div>
        </div>
        <span class="close-info2" @click="showJiJinInfo1 = false">×</span>
      </div>
    </div>
    <div class="perInfoBox2" v-if="showJiJinInfo3">
      <div
        class="info-txt3"
        style="margin-top: 12%; background: rgba(10, 88, 160, 0.8)"
      >
        <div style="width: 100%">
          <p class="intitle" style="background: #4a79fd">
            <span style="margin-left: 10px">活动详情</span>
          </p>
          <span class="close-info" @click="close">×</span>
        </div>
        <div style="overflow-y: scroll; height: 65vh">
          <p style="text-align: center; font-size: 20px">
            {{ huodongForm.name }}
          </p>
          <img
            :src="huodongForm.photo1"
            style="width: 50%; margin-left: 25%; margin-top: 10px"
          />
          <img
            :src="huodongForm.photo2"
            style="width: 50%; margin-left: 25%; margin-top: 10px"
          />
          <p style="margin: 20px">{{ huodongForm.content }}</p>
          <p style="margin: 20px">{{ huodongForm.content2 }}</p>
          <p style="margin: 20px">{{ huodongForm.content3 }}</p>
          <p style="margin: 20px">{{ huodongForm.content4 }}</p>
          <p style="margin: 20px">{{ huodongForm.content5 }}</p>
          <p style="margin: 20px">{{ huodongForm.content6 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
export default {
  name: "visualized",
  data() {
    return {
      huodongForm: {},
      showJiJinInfo3: false,
      alltotal: 0, //总数
      label1: "",
      label2: "",
      label3: "",
      label4: "",
      label5: "",
      scrollHeight: 786,
      activesList: [
        {
          id: "1",
          name: "家朋乡党坑村：“小灯泡”照亮老人心窝窝",
          photo1: require("./assets/big/wei1.png"),
          photo2: require("./assets/big/wei2.png"),
          content1:
            " “真是太谢谢许老师了”，家住党坑村方家的程一枝老人感慨地说道。",
          content2:
            " 程一枝是党坑村的建档立卡贫困户，年过八旬，平日独自一人住一间房，家中光线本就灰暗，白天不开灯几乎看不见。扬之小学的许晓雄老师是刚刚接替帮扶她的联系人，第一次来到程一枝的家中走访，许老师就发现家里的电线全部暴露在外面，并且严重老化、受损，有的甚至将要断裂。“这可不行！”许老师心里想着，默默记下了这件事。",
          content3:
            "回到学校，许老师立即和同事们商量，想帮助老人解决这个问题。于是大家筹集资金，请供电所人员对程一枝家中的线路进行整理维修，并换上了新灯泡。经过一番整理，原本杂乱破旧的电线变得整齐干净，更重要的是老人的用电安全得到了保障。",
          content4:
            "看着整修完好的线路，明亮起来的房屋，许老师露出了欣慰的笑容。程一枝心里也甚是感激，被照亮的不仅是房子，更是老人的心窝。",
        },
        {
          id: "2",
          name: "来安县开展“祝福百岁老人”走访慰问活动",
          // photo1:require("./assets/big/wei1.png"),
          // photo2:require("./assets/big/wei2.png"),
          content1:
            "为弘扬中华民族孝老爱亲传统美德，进一步发扬尊老敬老的良好社会风尚，在全国第八个“老年节”（重阳节）来临之际,来安县老龄委开展“祝福百岁老人”上门走访慰问活动。",
          content2:
            " 10月20日-22日，县老龄委一行到瀛洲镇、华阳镇、伏岭镇、家朋乡等乡镇，上门走访慰问了汪荷花、程月时、胡永耀、汪华娟等7位百岁老人，深入了解他们的生活和健康状况，与老人及家人们亲切交谈，嘱咐老人的子女用自己的孝心赡养好老人，并为每位老人送上1000元慰问金和慰问信。",
          content3:
            "据悉，目前来安县60岁以上老年人口4.46万人，占全县总人口的25.41%；80岁以上高龄老年人6168人，占全县老年人口的13.83%，百岁老人7人。近年来，来安县委、政府高度重视老龄工作，多措并举抓牢抓实老年人补贴工作，不断健全养老保障服务体系，逐步形成保障高龄老人基本生活长效机制，有力保障广大高龄老人的基本生活，老年人的幸福指数进一步得到提高。（邵红慧）",
        },
        {
          id: "3",
          name: "九九艳阳天 浓浓敬老情——安徽省徽州学校学生志愿者赴金沙镇敬老院慰问孤寡老人",
          photo1: require("./assets/big/wei3.jpg"),
          content1:
            "为弘扬中华民族孝老爱亲传统美德，进一步发扬尊老敬老的良好社会风尚，在全国第八个“老年节”（重阳节）来临之际,来安县老龄委开展“祝福百岁老人”上门走访慰问活动。",
          content2:
            " 10月20日-22日，县老龄委一行到瀛洲镇、华阳镇、伏岭镇、家朋乡等乡镇，上门走访慰问了汪荷花、程月时、胡永耀、汪华娟等7位百岁老人，深入了解他们的生活和健康状况，与老人及家人们亲切交谈，嘱咐老人的子女用自己的孝心赡养好老人，并为每位老人送上1000元慰问金和慰问信。",
          content3:
            "据悉，目前来安县60岁以上老年人口4.46万人，占全县总人口的25.41%；80岁以上高龄老年人6168人，占全县老年人口的13.83%，百岁老人7人。近年来，来安县委、政府高度重视老龄工作，多措并举抓牢抓实老年人补贴工作，不断健全养老保障服务体系，逐步形成保障高龄老人基本生活长效机制，有力保障广大高龄老人的基本生活，老年人的幸福指数进一步得到提高。（邵红慧）",
        },
        {
          id: "4",
          name: "计生政策帮渡难关 贫困老人安享晚年",
          photo1: require("./assets/big/wei4.png"),
          content1:
            "“多亏了乡卫计办为我申请的这笔特殊家庭帮扶资金，家里的情况好很多啦。”近日，来安县家朋乡尚村计生专干在上户走访慰问计生特殊家庭户周春月时，她满是感激的对工作人员这么说。",
          content2:
            "周春月是家朋尚村建档立卡贫困户，患有大病，生活困难，前两年，唯一的儿子不幸落水去世，突如其来的噩耗让一下子压垮了老两口。没有了唯一的家庭支柱，老两口又年事已高，这个本就不富裕的家庭更是雪上加霜。灾祸无情人有情，听闻了周春月家情况后，计生干部立即上户安抚老两口情绪，了解生活困难。2020年，周春月老两口到了计生特殊特扶年龄要求，计生专干第一时间上户告知并帮助办理申请手续。今年7月，周春月首次拿到了这笔帮扶资金，今后老两口每年能享受计生帮扶资金1.2万元，这给失去家中独子的家庭带来了极大的安慰，为老两口的晚年生活提供了保障。",
          content3:
            "一直以来，家朋乡卫计办积极参与脱贫攻坚工作，为符合计生政策的贫困户提供帮扶，给他们更多的关心关怀、鼓励他们勤劳致富，让他们感受到“计生人”的温暖，增强贫困群众脱贫致富奔小康的信心于决心。（郑雪婷）",
        },
        {
          id: "5",
          name: "来安县民政局：全力做好养老机构疫情防控工作 保障老人生命健康安全",
          photo1: require("./assets/big/wei5.jpg"),
          content:
            "为做好新型冠状病毒感染的肺炎疫情防控工作，切实保障老年人生命健康安全，县民政局高度重视，及时研究部署疫情防控工作，强化责任担当，积极采取有力措施筑牢疫情防控安全线。",
          content2:
            "一、加强宣传引导。各养老机构采取通俗易懂的方式加强对此次疫情严峻性和危害性的宣传，提高工作人员和院内老人防范疫情的意识和能力。耐心做好与老人家属的沟通，取得家属的支持和配合，以便共同做好防范工作。",
          content3:
            "二、实行封闭管理。全县所有养老机构一律实行封闭式管理，严禁院民和老人外出活动，院外无关人员不得入内，同时在此期间谢绝亲朋好友探视探望。各养老机构采购物资和对外联络工作，一律在院外完成交接对接，非本单位办事人员不得在院内聚集停留，所采购的所有食品要一律索票索证。各乡镇养老服务指导中心和村级养老服务中心一律封闭停止活动，防止聚集性传染事件发生。",
          content4:
            "三、细化院内防护。要求养老机构工作人员强化自身防护，自觉佩戴口罩，餐具要实行高温消毒，室内外定期进行卫生消毒消杀工作。工作人员上班前及院民每天均要测量体温，凡发现有发热和感冒症状的，立即送定点医院机构就医检查。",
          content5:
            "四、严格返院检查。春节前由亲属接出养老机构的，原则上在防范疫情期间不得返院。确需返院入住的，要联系卫健部门对其实行冠状病毒排查，并对其在院外期间是否直接或间接接触过湖北省尤其是武汉市相关人员的情况进行排查，在确保未携带冠状病毒的前提下方可返院。在防范疫情期间，各养老机构不得接收新入住对象。（来安县民政局）",
        },
        {
          id: "6",
          name: "我县有序推进高龄老人津贴补贴发放工作",
          content:
            "为全面落实《安徽省老年人权益保障条例》和《宣城市高龄老人津贴发放实施办法》，大力弘扬中华民族养老、爱老、尊老传统，体现党和政府的关心和照顾，不断提升高龄老人生活幸福感，我县民政、财政等部门通力合作，精准推进，全面做好高龄津贴发放民生工程工作，取得了良好效果。",
          content2:
            "一是精心部署，明确工作责任。县民政局印发《关于做好2019年度高龄津贴老年人津贴发放工作的通知》，优化健全老年人补贴发放制度，精心部署，狠抓落实，部署2019年高龄津贴发放管理各项工作，切实保障老年人权益，广泛接受社会监督。",
          content3:
            "二是点面结合,强化政策宣传。充分利用信息网络、政务宣传栏等形式广泛宣传高龄津贴补助发放对象、申请手续、发放标准及程序等内容，同时不定期做好上门入户宣传讲解工作，让群众知标准、明手续、晓流程，将政策带到群众身边，为高龄津贴制度的实施营造良好氛围。",
          content4:
            "三是完善程序，实行有序更新。按照个人申请、乡镇审核、县民政局审批的程序办理，同时结合人口变动网络数据系统实施动态化管理，对新申请符合条件的高龄老人按期办理审批、新增手续，对死亡人员及时办理停发手续，及时更新信息台账，做到数据真实、准确、完整。",
          content5:
            "四是加强保障，严格项目监管。县财政年初将补贴资金纳入项目预算，专款专用。按照公平、公正原则建立补贴资金检查监督制度，适时组织开展上门问卷调查或专项检查,及时发现存在的问题，确保资金不错发、不漏发，严防挪用、克扣、截留事件发生，增强工作透明度。",
          content6:
            "截至12月底，全县享受高龄津贴老人6265人，发放高龄津贴补贴311.2万元，全部发放到高龄老人个人银行账户中。（胡伟）",
        },
      ],
      oldJoin: [],
      showJiJinInfo2: false,
      showJiJinInfo1: false,
      map: null,
      marker: null,
      markers: [],
      recMarker: [],
      personList: [
        {
          personAge: "33",
          personSex: "2",
          personName: "张站",
          personPhone: "15222241123",
          address: "来安县新安镇",
          longitude: "118.434581",
          latitude: "32.428848",
        },
        {
          personAge: "35",
          personSex: "1",
          personName: "张丹",
          personPhone: "15226241123",
          address: "来安县半塔镇",
          longitude: "118.588275",
          latitude: "32.675221",
        },
        {
          personAge: "40",
          personSex: "1",
          personName: "方明",
          personPhone: "15246241123",
          address: "来安县汊河镇",
          longitude: "118.595726",
          latitude: "32.206585",
        },
        {
          personAge: "37",
          personSex: "1",
          personName: "李青",
          personPhone: "13462415613",
          address: "来安县水口镇",
          longitude: "118.497759",
          latitude: "32.317896",
        },
        {
          personAge: "37",
          personSex: "1",
          personName: "王复天",
          personPhone: "13462415613",
          address: "来安县舜山镇",
          longitude: "118.441856",
          latitude: "32.536382",
        },
        {
          personAge: "37",
          personSex: "1",
          personName: "林易",
          personPhone: "13475241613",
          address: "来安县雷官镇",
          longitude: "118.620944",
          latitude: "32.345538",
        },
        {
          personAge: "33",
          personSex: "1",
          personName: "吴飞",
          personPhone: "13475641613",
          address: "来安县施官镇",
          longitude: "118.580735",
          latitude: "32.455542",
        },
        {
          personAge: "35",
          personSex: "1",
          personName: "吴杨",
          personPhone: "13475612613",
          address: "来安县大英镇",
          longitude: "118.59775",
          latitude: "32.295551",
        },
        {
          personName: "2222",
          personAge: "111",
          personSex: "2",
          personPhone: "18945678901",
          address: "来安县张山镇",
          longitude: "118.498851",
          latitude: "32.496037",
        },
        {
          personAge: "108",
          personSex: "2",
          personName: "服务人员同步3号",
          personPhone: "13900000001",
          address: "来安县独山镇",
          longitude: "118.651457",
          latitude: "32.403991",
        },
        {
          personAge: "21",
          personSex: "1",
          personName: "服务人员同步1号12",
          personPhone: "18822222341",
          address: "来安县三城乡",
          longitude: "118.450073",
          latitude: "32.25309",
        },
        {
          personAge: "42",
          personSex: "2",
          personName: "全功能服务1",
          personPhone: "18809090900",
          address: "来安县独山乡",
          longitude: "118.651457",
          latitude: "32.403991",
        },
        {
          personAge: "44",
          personSex: "2",
          personName: "服务",
          personPhone: "13934563456",
          address: "来安县杨郢乡",
          longitude: "118.46178",
          latitude: "32.644449",
        },
      ],
      pInfo: {
        personAge: "",
        personSex: "",
        personName: "",
        personPhone: "",

        address: "",
      },
      stationList: [
        {
          id: "0",
          stationName: "华阳镇东山社区养老机构",
          stationAddress: "安徽省宣城市来安县华阳镇东山社区",
          concatNam: "唐韫",
          phone: "15345636282",
          longitude: "118.608415",
          latitude: "30.07887",
        },
        {
          id: "1",
          stationName: "华阳镇杨柳社区养老机构",
          stationAddress: "安徽省宣城市来安县华阳镇杨柳社区",
          concatNam: "周正益",
          phone: "13966203888",
          longitude: "118.596285",
          latitude: "30.066105",
        },
        {
          id: "2",
          stationName: "华阳镇霞涧社区养老机构",
          stationAddress: "安徽省宣城市来安县华阳镇霞涧社区",
          concatNam: "汪沛",
          phone: "18098565555",
          longitude: "118.579815",
          latitude: "30.072999",
        },
        {
          id: "3",
          stationName: "华阳镇凤灵社区养老机构",
          stationAddress: "安徽省宣城市来安县华阳镇凤灵社区",
          concatNam: "许令星",
          phone: "13966203039",
          longitude: "118.590762",
          latitude: "30.059501",
        },
        {
          id: "4",
          stationName: "华阳镇来苏社区养老机构",
          stationAddress: "安徽省宣城市来安县华阳镇来苏社区",
          concatNam: "邵鹏",
          phone: "13655637311",
          longitude: "118.592986",
          latitude: "30.071278",
        },
        {
          id: "5",
          stationName: "华阳镇五龙社区养老机构",
          stationAddress: "安徽省宣城市来安县华阳镇五龙社区",
          concatNam: "吴继光",
          phone: "18098567909",
          longitude: "118.602642",
          latitude: "30.077145",
        },
      ],
      info: {
        stationName: "",
        stationAddress: "",
        concatNam: "",
        phone: "",
      },
    }
  },
  filters: {},
  computed: {
    defaultOption() {
      return {
        oldJoin: [],
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 9, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  mounted() {
    const self = this
    self.$nextTick(() => {
      self.loadMap().then(() => {
        self.getDistrict()
        self.getStation() //站点
        self.currentBulidingArea() //建筑面积
        self.currentBednums() //床位数
        self.getactivesList() //获取活动列表数据
        self.getSiteData()
        self.bathPoint()
        self.serverList()
      })
    })
  },
  methods: {
    showInfo(id) {
      this.showJiJinInfo3 = true
      this.activesList.forEach((item) => {
        if (id == item.id) {
          this.huodongForm = item
        }
      })
    },
    close() {
      this.showJiJinInfo3 = false
    },
    // 服务人员
    serverList() {
      // recMarker
      const self = this
      let f1 = require("./assets/big/adIcon4.png")
      this.personList.forEach((item, i) => {
        let icon = f1
        let marker = new AMap.Marker({
          position: [item.longitude, item.latitude],
          icon: new AMap.Icon({
            image: icon,
            size: new AMap.Size(52, 52), //图标大小
            imageSize: new AMap.Size(30, 30),
          }),
          extData: {
            personAge: item.personAge,
            personSex: item.personSex,
            personName: item.personName,
            personPhone: item.personPhone,
            address: item.address,
          },
        })
        self.recMarker.push(marker)

        marker.on("click", self.maskServe)
      })
      self.map.add(self.recMarker)
    },
    maskServe(e) {
      let data = e.target.w.extData
      this.pInfo = {
        personAge: data.personAge,
        personSex: data.personSex,
        personName: data.personName,
        personPhone: data.personPhone,
        address: data.address,
      }
      this.showJiJinInfo1 = true
    },
    // 批量打点
    bathPoint() {
      const self = this
      let f1 = require("./assets/big/adIcon1.png")
      this.stationList.forEach((item, i) => {
        let icon = f1
        let marker = new AMap.Marker({
          position: [item.longitude, item.latitude],
          icon: new AMap.Icon({
            image: icon,
            size: new AMap.Size(52, 52), //图标大小
            imageSize: new AMap.Size(30, 30),
          }),
          extData: {
            id: item.id,
            stationName: item.stationName,
            stationAddress: item.stationAddress,
            concatNam: item.concatNam,
            phone: item.phone,
          },
        })
        self.markers.push(marker)

        marker.on("click", self.maskModel)
      })
      self.map.add(self.markers)
    },
    maskModel(e) {
      let data = e.target.w.extData
      this.info = {
        stationName: data.stationName,
        stationAddress: data.stationAddress,
        concatNam: data.concatNam,
        phone: data.phone,
      }
      this.showJiJinInfo2 = true
      // console.log(e.target.w.extData, "点击事件")
    },
    // 老人参与
    olderJoins() {
      let xData = []

      if (this.oldJoin == [] || this.oldJoin == null) {
        xData = []
      } else {
        this.oldJoin.forEach((item) => {
          xData.push(item.participantsNumber)
        })
      }
      const myChart = this.$echarts.init(document.getElementById("olderJoin"))
      var option
      option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#fff",
              width: "1", //坐标线的宽度
            },
          },
          data: ["志愿", "养生", "健身", "法律", "其他"],
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#fff",
              width: "1", //坐标线的宽度
            },
          },
        },
        series: [
          {
            data: xData,
            type: "bar",
            smooth: true,
            // color: "#D800FF",
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList2 = [
                    "#D800FF",
                    "#7FD42D",
                    "#F21B62",
                    "#0F5BF5",
                    "#50b7c1",
                  ]
                  return colorList2[params.dataIndex]
                },
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 16,
                  },
                },
              },
            },
          },
        ],
      }
      option && myChart.setOption(option)
    },
    getSiteData() {
      const self = this
      let params = {
        pageNo: 1,
        pageSize: 10,
      }
      this.$http
        .request({
          url: "/ypt/admin/site/info/getSiteData",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            let data = res.content
            let activityTotal = data.dataByLabel //活动总数  标签
            this.alltotal = data.dataByLabel.total //总数
            if (activityTotal.label1 == 0) {
              this.label1 = 0
            } else {
              this.label1 = (activityTotal.label1 / this.alltotal) * 100
              this.label1 = Number(this.label1)
              if ((this.label1 + "").indexOf(".") != -1) {
                //判断是否有小数点
                this.label1 = this.label1.toFixed(2)
              } else {
                this.label1 = this.label1
              }
            }
            if (activityTotal.label2 == 0) {
              this.label2 = 0
            } else {
              this.label2 = (activityTotal.label2 / this.alltotal) * 100
              this.label2 = Number(this.label2)
              if ((this.label2 + "").indexOf(".") != -1) {
                //判断是否有小数点
                this.label2 = this.label2.toFixed(2)
              } else {
                this.label2 = this.label2
              }
            }
            if (activityTotal.label3 == 0) {
              this.label3 = 0
            } else {
              this.label3 = (activityTotal.label3 / this.alltotal) * 100
              this.label3 = Number(this.label3)
              if ((this.label2 + "").indexOf(".") != -1) {
                //判断是否有小数点
                this.label3 = this.label3.toFixed(2)
              } else {
                this.label3 = this.label3
              }
            }
            if (activityTotal.label4 == 0) {
              this.label4 = 0
            } else {
              this.label4 = (activityTotal.label4 / this.alltotal) * 100
              this.label4 = Number(this.label4)
              if ((this.label4 + "").indexOf(".") != -1) {
                //判断是否有小数点
                this.label4 = this.label4.toFixed(2)
              } else {
                this.label4 = this.label4
              }
            }
            if (activityTotal.label5 == 0) {
              this.label5 = 0
            } else {
              this.label5 = (activityTotal.label5 / this.alltotal) * 100
              if ((this.label5 + "").indexOf(".") != -1) {
                //判断是否有小数点
                this.label5 = this.label5.toFixed(2)
              } else {
                this.label5 = this.label5
              }
            }
            self.oldJoin = data.numberDataByLabel //老人参与
            self.olderJoins()
          }
        })
    },
    getactivesList() {
      // let params = {
      //   pageNo: -1,
      //   pageSize: 999,
      // }
      // this.$http
      //   .request({
      //     url: "/ypt/admin/activityList/info/findListVisualization",
      //     method: "POST",
      //     data: params,
      //   })
      //   .then((res) => {
      //     if (res.code == 200) {
      //       this.activesList = res.content.list
      //     }
      //   })
    },
    format(percentage) {
      return ""
    },
    //工作人数
    currentBednums() {
      let xData = [
          "新安镇敬老院",
          "半塔镇敬老院",
          "水口镇敬老院",
          "汊河镇敬老院",
          "大英镇敬老院",
          "雷官镇敬老院",
          "施官镇敬老院",
          "舜山镇敬老院",
          "三城乡敬老院",
          "独山乡敬老院",
          "张山乡敬老院",
          "杨郢乡敬老院",
        ],
        yData = ["3", "4", "6", "5", "3", "5", "4", "6", "4", "3", "7"]
      const myChart = this.$echarts.init(document.getElementById("bedNums"))
      var option
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "15%",
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#fff",
              width: "1", //坐标线的宽度
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 65,
            textStyle: {
              color: "#BAC0EB",
              fontSize: "10",
            },
            formatter: function (params) {
              var tempStr = params.substring(0, 4)
              var tempStr1 = params.substring(4, params.length)
              var tempStr2 = tempStr + "\n" + tempStr1
              return tempStr2
            },
          },
          data: xData,
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#1540B6", //左边线的颜色
              width: "1", //坐标线的宽度
            },
          },
          axisLabel: {
            textStyle: {
              color: "#BAC0EB",
              fontSize: "12",
            },
          },
        },
        dataZoom: {
          show: true,
          realTime: true,
          height: 20,
          start: 20,
          end: 80,
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            data: yData,
            type: "bar",
            barWidth: 12,
            color: "#0F5BF5",
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 16,
                  },
                },
              },
            },
          },
        ],
      }
      option && myChart.setOption(option)
    },
    // 建筑面积
    currentBulidingArea() {
      let xData = [
          "新安镇敬老院",
          "半塔镇敬老院",
          "水口镇敬老院",
          "汊河镇敬老院",
          "大英镇敬老院",
          "雷官镇敬老院",
          "施官镇敬老院",
          "舜山镇敬老院",
          "三城乡敬老院",
          "独山乡敬老院",
          "张山乡敬老院",
          "杨郢乡敬老院",
        ],
        yData = [
          "1100",
          "1200",
          "2500",
          "3400",
          "1050",
          "2050",
          "1700",
          "5860",
          "854",
          "350",
          "6670",
          "1152",
        ]
      const myChart = this.$echarts.init(
        document.getElementById("currentBulidingArea")
      )
      var option
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: [],
        },
        grid: {
          left: "14%",
        },
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: xData,
            axisLabel: {
              formatter: "{value}",
              // rotate: 65,
              textStyle: {
                fontSize: "10",
                color: "#fff",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                fontSize: "10",
                color: "#fff",
              },
            },
          },
        ],
        dataZoom: {
          show: true,
          realTime: true,
          height: 20,
          start: 20,
          end: 80,
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            name: "",
            type: "line",
            stack: "总量",
            smooth: true,
            center: ["30%", "40%"],
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: "#F21B62",
            },
            emphasis: {
              focus: "series",
            },
            data: yData,
          },
        ],
      }
      option && myChart.setOption(option)
    },
    // 站点等级占比
    getStation() {
      const myChart = this.$echarts.init(
        document.getElementById("currentSituation")
      )
      var option
      option = {
        legend: {
          icon: "circle",
          textStyle: { color: "#FFFDFE" },
          bottom: 0,
          selectedMode: true, //取消图例上的点击事件
          data: ["AAAAA", "AAAA", "AAA", "AA", "A"],
        },
        //点击提示文字
        tooltip: {
          show: true,
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        //环形颜色
        color: ["#D800FF", "#FFB026", "#0F5BF5", "#009ad6", "#45b97c"],
        series: [
          {
            name: "",
            type: "pie",
            radius: ["35%", "50%"], //两个表示环：内半径,外半径
            center: ["50%", "50%"], //左右，上下
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: true,
                position: "outside",
                // formatter: '{d}%, {c} \n\n',
                //模板变量有 {a}, {b}，{c}，{d}，{e}，分别表示系列名，数据名，数据值等。
                // formatter: "{d}%",
                borderWidth: 5,
                borderRadius: 4,
                //  padding: [90, -50],
                rich: {
                  a_set: {
                    color: "#FFF",
                    lineHeight: 20,
                    align: "center",
                  },
                  c_set: {
                    color: "#FFF",
                  },
                },
              },
            },
            //牵引线条颜色
            labelLine: {
              normal: {
                show: true,
                showAbove: true,
                length: 20,
                length2: 35,
                lineStyle: {
                  color: "orange",
                },
              },
            },
            data: [
              { value: "0", name: "A" },
              { value: "47.06", name: "AA" },
              { value: "52.49", name: "AAA" },
              { value: "0", name: "AAAA" },
              { value: "0", name: "AAAAA" },
            ],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b} :({d}%)",
                },
                labelLine: { show: true },
              },
            },
          },
        ],
      }
      option && myChart.setOption(option)
    },
    loadMap() {
      //地图加载
      return new Promise((resolve, reject) => {
        this.map = new AMap.Map("container", {
          resizeEnable: true,
          mapStyle: "amap://styles/darkblue",
          zoom: 10,
          center: ["118.84315", "32.458977"],
        })
        this.setArea()
        resolve()
      })
    },
    setArea() {
      let arr = [
        {
          pointPosition:
            "118.50145:32.721362,118.49939:32.711732,118.519561:32.676916,118.535611:32.676555,118.538529:32.67576,118.538357:32.672003,118.532349:32.668679,118.526513:32.663477,118.51175:32.654806,118.50557:32.651626,118.49733:32.645845,118.495614:32.641219,118.492524:32.634281,118.493897:32.626185,118.494927:32.607677,118.511407:32.58743,118.512093:32.579909,118.512093:32.572966,118.51278:32.567179,118.521706:32.560235,118.531319:32.558498,118.542306:32.561392,118.549859:32.55792,118.551919:32.558498,118.556768:32.560343,118.569557:32.586273,118.574878:32.588334,118.577968:32.593613,118.592045:32.598965,118.599769:32.603809,118.608953:32.597518,118.621828:32.594915,118.624918:32.591733,118.628694:32.590287,118.632428:32.580054,118.638221:32.581645,118.643071:32.588696,118.650452:32.592818,118.65307:32.598748,118.654958:32.599001,118.658306:32.598458,118.664056:32.596,118.679451:32.596589,118.689086:32.589719,118.701553:32.589701,118.703218:32.600432,118.699115:32.602867,118.70092:32.606048,118.700775:32.613264,118.696054:32.616951,118.695679:32.618515,118.702202:32.621723,118.704133:32.627135,118.685368:32.634318,118.675412:32.6314,118.673749:32.63327,118.671539:32.635692,118.666003:32.637833,118.665573:32.641506,118.674414:32.64895,118.682482:32.649167,118.687289:32.652563,118.693726:32.650973,118.695357:32.651985,118.693125:32.660368,118.698618:32.666437,118.699562:32.673662,118.694842:32.692734,118.697846:32.69779,118.700764:32.700318,118.712008:32.703568,118.716299:32.715196,118.713553:32.718445,118.706429:32.716712,118.69982:32.721695,118.695958:32.721767,118.689434:32.728699,118.679135:32.728554,118.657505:32.735414,118.652356:32.741406,118.647377:32.742128,118.640339:32.744077,118.633473:32.739023,118.628237:32.742056,118.619053:32.740467,118.60738:32.728266,118.591502:32.723211,118.583948:32.722995,118.571846:32.718301,118.569701:32.719601,118.564894:32.729277,118.559272:32.729854,118.538287:32.727435,118.535626:32.727652,118.530905:32.726208,118.529188:32.725847,118.526184:32.726858,118.520434:32.723536,118.51228:32.725341",
          gridColour: "1565C0",
          orgName: "半塔镇",
        },
        {
          pointPosition:
            "118.402236:32.551454,118.420221:32.55816,118.422324:32.559715,118.428418:32.567257,118.413273:32.586431,118.406117:32.595628,118.39954:32.595749,118.395614:32.596797,118.39158:32.595496,118.376162:32.597295,118.370851:32.592965,118.365133:32.582063,118.35685:32.573384,118.353374:32.566368,118.34492:32.564342,118.34286:32.560798,118.342216:32.557434,118.346851:32.552514,118.347881:32.547052,118.351872:32.540685,118.336337:32.515501,118.336895:32.498491,118.33874:32.49708,118.34286:32.500627,118.347581:32.495632,118.354576:32.477604,118.351743:32.475251,118.342259:32.476953,118.341959:32.476989,118.342989:32.483035,118.339126:32.484374,118.333461:32.482383,118.328355:32.474817,118.331702:32.462398,118.331444:32.461963,118.324235:32.460985,118.319385:32.455807,118.31887:32.448275,118.330801:32.440887,118.332689:32.443965,118.336766:32.445667,118.336895:32.445559,118.337324:32.442842,118.340113:32.44277,118.345778:32.436576,118.344748:32.429912,118.352516:32.42926,118.354962:32.41861,118.354962:32.418139,118.348954:32.413139,118.348793:32.412994,118.350284:32.412188,118.350201:32.412233,118.350169:32.411799,118.350582:32.412199,118.3511:32.412358,118.352425:32.412415,118.353178:32.412034,118.355851:32.411244,118.359348:32.411389,118.365678:32.412648,118.38072:32.414577,118.389496:32.412711,118.400826:32.399414,118.445072:32.398436,118.471636:32.40224,118.473053:32.43307,118.476143:32.444515,118.473053:32.483403,118.472945:32.483874,118.455853:32.481793,118.409418:32.486064,118.401865:32.490046,118.402209:32.497358,118.400921:32.506985,118.392767:32.511039,118.388132:32.514296,118.383583:32.52204,118.385386:32.531954,118.401608:32.550712,118.401608:32.550712,118.40197:32.551144",
          gridColour: "1565C0",
          orgName: "新安镇",
        },
        {
          pointPosition:
            "118.480365:32.259,118.484753:32.255661,118.494623:32.247724,118.531444:32.229575,118.539555:32.226997,118.55007:32.221697,118.558309:32.216904,118.568051:32.218139,118.58335:32.201572,118.585807:32.20051,118.588833:32.200301,118.590308:32.200637,118.59217:32.200206,118.592336:32.200097,118.592363:32.195319,118.594742:32.194706,118.597035:32.199759,118.610564:32.202383,118.619147:32.205869,118.62758:32.202709,118.629747:32.203345,118.636721:32.207757,118.644274:32.210335,118.649832:32.217724,118.666225:32.23368,118.671976:32.245132,118.67586:32.254641,118.673907:32.25622,118.66998:32.256456,118.660645:32.261555,118.649187:32.259704,118.647921:32.259976,118.646188:32.261323,118.644954:32.262153,118.642937:32.263242,118.641693:32.262879,118.640019:32.265057,118.596031:32.278287,118.584358:32.274223,118.567192:32.27045,118.548309:32.271611,118.534919:32.273062,118.514663:32.272482,118.505737:32.272772,118.502304:32.273353,118.497154:32.274223,118.493034:32.274804,118.483764:32.275385,118.483421:32.275385,118.481361:32.273788,118.480503:32.272191,118.481704:32.269288,118.484107:32.268272,118.482906:32.264208,118.481532:32.262031,118.480846:32.260126",
          gridColour: "FC466B",
          orgName: "汉河镇",
        },
        {
          pointPosition:
            "118.406144:32.595644,118.413407:32.586327,118.413517:32.586485,118.420558:32.577698,118.428283:32.566704,118.466391:32.571912,118.473601:32.577409,118.480468:32.580302,118.487334:32.578277,118.490424:32.57249,118.493514:32.566704,118.49832:32.558313,118.512397:32.567246,118.511753:32.573033,118.511753:32.579868,118.511195:32.587389,118.49472:32.607773,118.493733:32.62628,118.492317:32.634376,118.495643:32.641351,118.497295:32.64603,118.505471:32.651631,118.52651:32.663496,118.532314:32.668698,118.538349:32.672006,118.538523:32.675756,118.535609:32.676553,118.519553:32.676912,118.499377:32.711737,118.5014:32.721356,118.490725:32.723875,118.490124:32.722972,118.489974:32.722728,118.487098:32.721501,118.483901:32.720427,118.480135:32.722404,118.479588:32.722485,118.474878:32.721059,118.469599:32.721275,118.466531:32.722458,118.464943:32.723595,118.461403:32.724064,118.458774:32.725328,118.456843:32.72948,118.454536:32.732566,118.451039:32.743883,118.448528:32.745616,118.441232:32.739606,118.431813:32.716735,118.427693:32.711806,118.418423:32.707184,118.414732:32.70072,118.419904:32.696079,118.421277:32.683908,118.428358:32.677406,118.434023:32.664148,118.431298:32.660065,118.42662:32.657229,118.420097:32.659595,118.415762:32.656181,118.414303:32.650508,118.415548:32.640318,118.419195:32.636469,118.427392:32.635078,118.427328:32.625807,118.417457:32.615452,118.413509:32.61462,118.409475:32.612704,118.408896:32.609686,118.41014:32.606053,118.410097:32.606053",
          gridColour: "3F5EFB",
          orgName: "杨郢乡",
        },
        {
          pointPosition:
            "118.402258:32.551458,118.419606:32.558199,118.422525:32.559863,118.424112:32.561346,118.428265:32.566681,118.466438:32.571904,118.473642:32.57741,118.480466:32.58024,118.487332:32.578224,118.498293:32.558294,118.496244:32.545145,118.493884:32.536969,118.496931:32.528756,118.49796:32.522351,118.494613:32.513196,118.488734:32.504727,118.490279:32.487208,118.486845:32.487244,118.474829:32.493362,118.472769:32.483869,118.456375:32.481862,118.442213:32.482224,118.42685:32.484722,118.410113:32.48617,118.402302:32.490152,118.402216:32.497536,118.4008:32.507381,118.39359:32.510747,118.387968:32.514221,118.383634:32.522037,118.385737:32.532349,118.392013:32.539558",
          gridColour: "59C173",
          orgName: "舜山镇",
        },
        {
          pointPosition:
            "118.577353:32.550531,118.572665:32.543043,118.574682:32.536205,118.576012:32.535373,118.579102:32.534866,118.580003:32.53407,118.58202:32.530597,118.582192:32.524699,118.575326:32.51985,118.556646:32.520256,118.5545:32.520921,118.551453:32.518605,118.545745:32.515239,118.539566:32.51466,118.533558:32.513285,118.529695:32.510462,118.527292:32.497143,118.529953:32.49584,118.551153:32.492872,118.539566:32.467168,118.538622:32.464054,118.539394:32.461809,118.557513:32.449868,118.558307:32.447967,118.55438:32.442806,118.540948:32.441205,118.52052:32.440119,118.511079:32.439612,118.504813:32.425423,118.506186:32.412961,118.5376:32.403831,118.483355:32.379044,118.478377:32.379044,118.473227:32.379479,118.472712:32.380059,118.471339:32.379479,118.453143:32.378754,118.444388:32.37252,118.438037:32.364872,118.43279:32.352714,118.430269:32.354019,118.427206:32.360742,118.414867:32.366989,118.411047:32.371665,118.40609:32.370976,118.402679:32.367352,118.399975:32.367714,118.389611:32.372897,118.391778:32.377084,118.384654:32.385751,118.382026:32.381407,118.376683:32.387378,118.372531:32.390096,118.368958:32.390449,118.366919:32.39333,118.371533:32.394055,118.375095:32.402352,118.376597:32.404273,118.37694:32.407606,118.372048:32.410903,118.36222:32.406882,118.35647:32.406555,118.35029:32.408838,118.349971:32.408931,118.350185:32.411748,118.350182:32.411795,118.350561:32.412176,118.350756:32.412232,118.350866:32.412269,118.351121:32.412371,118.35243:32.412414,118.353203:32.412024,118.355778:32.411254,118.359372:32.41139,118.364704:32.4125,118.365798:32.412681,118.380647:32.41451,118.38938:32.412717,118.400753:32.399402,118.444998:32.398568,118.471606:32.402264,118.473108:32.432442,118.47637:32.44577,118.47225:32.483862,118.474825:32.493237,118.486841:32.487265,118.490317:32.487301,118.488772:32.504783,118.494652:32.51318,118.498085:32.522444,118.497012:32.52874,118.493922:32.537061,118.496282:32.545129,118.498428:32.558369,118.512581:32.56722,118.521679:32.560203,118.531743:32.558394,118.531306:32.558473,118.542304:32.561365,118.549868:32.557892,118.55196:32.558471,118.556842:32.560343,118.558644:32.555415,118.56315:32.551978,118.575252:32.550739",
          gridColour: "19D313",
          orgName: "张山镇",
        },
        {
          pointPosition:
            "118.610594:32.472291,118.607447:32.439745,118.624785:32.435108,118.628733:32.425836,118.629591:32.41888,118.62736:32.413374,118.618433:32.409171,118.611395:32.402214,118.608477:32.394242,118.607619:32.391923,118.590109:32.389024,118.587191:32.391488,118.579123:32.389604,118.578951:32.399895,118.563845:32.39946,118.552:32.405548,118.545649:32.405982,118.53764:32.403854,118.506239:32.412918,118.504716:32.425471,118.51111:32.439488,118.540937:32.441118,118.554283:32.442712,118.558274:32.447818,118.557459:32.450136,118.539477:32.461833,118.538619:32.464223,118.539649:32.467336,118.55124:32.492887,118.529825:32.495999,118.527465:32.497158,118.529782:32.510368,118.533259:32.513191,118.539868:32.514675,118.545661:32.515218,118.551455:32.518474,118.554545:32.520899,118.556862:32.52032,118.575487:32.51985,118.582311:32.524662,118.582053:32.530958,118.580079:32.534251,118.57935:32.534938,118.575992:32.535454,118.574715:32.536195,118.572685:32.543045,118.577384:32.550558,118.609312:32.535044,118.608915:32.53219,118.605391:32.531032,118.605242:32.531009,118.602519:32.530188,118.603545:32.521139,118.606463:32.518189,118.617063:32.516597,118.618179:32.515566,118.616785:32.50831,118.616779:32.508132,118.610374:32.507114,118.608883:32.502065,118.592249:32.502157,118.593333:32.496239,118.591595:32.484366,118.594298:32.47785,118.59786:32.476329,118.605199:32.47756",
          gridColour: "133DD3",
          orgName: "施官镇",
        },

        {
          pointPosition:
            "118.607646:32.391909,118.608898:32.385628,118.609992:32.384378,118.611473:32.383308,118.613103:32.383109,118.616515:32.387857,118.627591:32.396598,118.628879:32.397178,118.630338:32.396308,118.636432:32.38935,118.648169:32.372643,118.648599:32.372534,118.670802:32.380435,118.667197:32.388263,118.6693:32.390039,118.671446:32.39022,118.680276:32.388462,118.677744:32.393862,118.685271:32.404388,118.688619:32.418953,118.685958:32.429241,118.689477:32.45032,118.691515:32.452619,118.690872:32.455824,118.68585:32.454339,118.683619:32.458975,118.685486:32.460061,118.690721:32.459319,118.69176:32.465047,118.690772:32.472269,118.685751:32.472957,118.673435:32.4693,118.649831:32.47665,118.64245:32.470061,118.631721:32.470712,118.63009:32.468685,118.627215:32.467852,118.619404:32.472305,118.610599:32.472299,118.607468:32.439799,118.624903:32.435109,118.628808:32.425582,118.629666:32.418808,118.627392:32.413374,118.618294:32.409099,118.611384:32.402106,118.611384:32.402106,118.611384:32.402106,118.607653:32.391981",
          gridColour: "171E98",
          orgName: "独山镇",
        },
        {
          pointPosition:
            "118.608894:32.385623,118.609332:32.378157,118.591737:32.337483,118.571653:32.336033,118.566159:32.333422,118.560666:32.327765,118.597573:32.31616,118.619031:32.317611,118.635167:32.303175,118.639545:32.299693,118.642463:32.29933,118.648814:32.296791,118.657092:32.299598,118.65714:32.301934,118.659586:32.305272,118.670744:32.309932,118.674692:32.314158,118.676559:32.315826,118.686794:32.318347,118.69497:32.317404,118.697266:32.318165,118.696386:32.320777,118.694004:32.321973,118.68894:32.321955,118.684134:32.323751,118.682975:32.326543,118.684134:32.327703,118.687846:32.330369,118.697116:32.329063,118.703446:32.329607,118.706857:32.332291,118.707716:32.338292,118.704905:32.339996,118.697395:32.341936,118.695957:32.346015,118.699583:32.349513,118.694047:32.349731,118.692184:32.352554,118.69536:32.357086,118.699308:32.357231,118.702012:32.357956,118.701969:32.358209,118.69978:32.359949,118.695961:32.360819,118.696304:32.364843,118.695704:32.367852,118.697592:32.36941,118.700596:32.368078,118.702312:32.36777,118.703697:32.368223,118.703396:32.371948,118.702109:32.373062,118.697731:32.373325,118.696809:32.375327,118.700692:32.376687,118.701787:32.377937,118.701572:32.379595,118.698514:32.383328,118.696133:32.383808,118.694019:32.382513,118.693729:32.380175,118.692345:32.377692,118.690747:32.377384,118.688215:32.38437,118.680254:32.38842,118.671424:32.390214,118.669235:32.390014,118.667218:32.388257,118.670856:32.380402,118.648668:32.372518,118.648089:32.372663,118.636395:32.389371,118.630279:32.396383,118.628841:32.397144,118.627618:32.3966,118.616503:32.387831,118.612984:32.383029,118.611353:32.383337,118.609916:32.384388",
          gridColour: "EE1919",
          orgName: "雷官镇",
        },
        {
          pointPosition:
            "118.573571:32.323689,118.55366:32.30881,118.552072:32.307632,118.550978:32.305709,118.55042:32.304367,118.559715:32.298275,118.567011:32.293922,118.573759:32.271899,118.584359:32.274222,118.596107:32.27844,118.640095:32.265041,118.641705:32.262909,118.642928:32.263254,118.644999:32.262165,118.646265:32.261312,118.64738:32.260441,118.647895:32.259988,118.649236:32.259716,118.66095:32.261614,118.658892:32.26583,118.663365:32.274396,118.670446:32.285172,118.669802:32.292755,118.66697:32.295983,118.660404:32.295693,118.657067:32.299593,118.648805:32.296768,118.642443:32.299316,118.639514:32.299679,118.619029:32.317599,118.59754:32.316142",
          gridColour: "2EE919",
          orgName: "大英镇",
        },
        {
          pointPosition:
            "118.421426:32.265965,118.424526:32.264885,118.425825:32.263706,118.441392:32.265602,118.450276:32.266999,118.455254:32.268251,118.462732:32.267852,118.480358:32.259023,118.481511:32.262017,118.482895:32.264221,118.484097:32.268267,118.481683:32.269283,118.480503:32.272186,118.481372:32.27381,118.483399:32.275361,118.493141:32.274808,118.497347:32.274209,118.504761:32.27293,118.505876:32.272749,118.514019:32.272486,118.515232:32.272458,118.534994:32.273066,118.549175:32.27156,118.5675:32.270399,118.57376:32.271897,118.567029:32.293912,118.564733:32.295227,118.55042:32.304405,118.552137:32.307724,118.573562:32.323697,118.560658:32.327764,118.566312:32.333593,118.571763:32.336131,118.591761:32.337509,118.609324:32.378165,118.608898:32.38564,118.607637:32.391919,118.590095:32.388954,118.58722:32.391454,118.579109:32.389606,118.578809:32.399861,118.563788:32.39939,118.551815:32.405586,118.545464:32.406021,118.53761:32.403847,118.483365:32.378987,118.473151:32.379386,118.472711:32.38002,118.471263:32.379431,118.45293:32.378645,118.444003:32.372193,118.437566:32.364255,118.43291:32.352745,118.436772:32.35057,118.435506:32.345404,118.43851:32.342177,118.437158:32.34031,118.421108:32.338297,118.419262:32.337318,118.419198:32.3342,118.424992:32.324935,118.431129:32.319749,118.43115:32.317699,118.42821:32.311606,118.434497:32.308215,118.428918:32.296154,118.429187:32.275365,118.423099:32.268019",
          gridColour: "DFC925",
          orgName: "水口镇",
        },
        {
          pointPosition:
            "118.421418:32.265923,118.419299:32.263414,118.415383:32.264031,118.408817:32.269461,118.40268:32.26996,118.397186:32.268799,118.396006:32.264761,118.395899:32.260552,118.397369:32.258855,118.399257:32.258737,118.400115:32.260461,118.401982:32.261867,118.404375:32.261269,118.405694:32.257785,118.404858:32.253538,118.40636:32.252949,118.411456:32.252386,118.415533:32.247459,118.416863:32.247214,118.419835:32.248403,118.42256:32.248612,118.423719:32.245926,118.423408:32.243222,118.416681:32.241933,118.415511:32.241298,118.415683:32.23814,118.416037:32.235644,118.416065:32.235439,118.414198:32.233034,118.415142:32.23092,118.420174:32.229967,118.423049:32.227943,118.424433:32.223432,118.428768:32.219057,118.429122:32.215381,118.430838:32.212894,118.43469:32.210933,118.440505:32.210252,118.444732:32.204315,118.446545:32.204515,118.449099:32.208255,118.450504:32.208872,118.456823:32.206766,118.457821:32.206857,118.458808:32.210407,118.460246:32.211332,118.463347:32.210243,118.463904:32.208001,118.461297:32.205232,118.460439:32.203834,118.462027:32.202618,118.463776:32.202318,118.466715:32.204379,118.468539:32.205296,118.470621:32.20535,118.472434:32.203144,118.472509:32.200048,118.474269:32.19875,118.489355:32.198384,118.496683:32.196731,118.508606:32.195096,118.517704:32.189321,118.522553:32.188195,118.526158:32.189902,118.529978:32.194714,118.532338:32.196131,118.539462:32.192408,118.548324:32.195096,118.548903:32.198273,118.550899:32.200144,118.556371:32.198419,118.561327:32.196821,118.566563:32.199835,118.562829:32.202885,118.569567:32.20343,118.572314:32.206843,118.57785:32.204519,118.576605:32.20245,118.579051:32.199327,118.584802:32.198818,118.588858:32.200298,118.585789:32.200507,118.583322:32.201578,118.568001:32.218118,118.558173:32.216883,118.550105:32.221712,118.540192:32.226722,118.530793:32.229772,118.494401:32.247776,118.480357:32.259014,118.462703:32.267827,118.455235:32.268226,118.449914:32.26692,118.441867:32.265668,118.425624:32.263636,118.424487:32.264861,118.424117:32.264995",
          gridColour: "1EF705",
          orgName: "三城镇",
        },
      ]
      arr.forEach((item) => {
        let polygonArr = []
        if (item.pointPosition) {
          item.pointPosition.split(",").forEach((e) => {
            polygonArr.push(e.split(":"))
          })
          var polygon = new AMap.Polygon({
            map: this.map,
            path: polygonArr, //设置多边形边界路径
            strokeColor: "#" + item.gridColour, //线颜色
            strokeOpacity: 0.2, //线透明度
            strokeWeight: 3, //线宽
            fillColor: "#" + item.gridColour, //填充色
            fillOpacity: 0.35, //填充透明度
            // extData: {
            //     name: item.orgName,
            // },
          })
          this.text3 = new AMap.Text({
            text: item.orgName,
            anchor: "center", //  设置文本标记锚点
            draggable: true,
            cursor: "pointer",
            angle: 10,
            style: {
              "text-align": "center",
              "font-size": "15px",
              "background-color": "transparent",
              color: "#fff",
              "border-width": 0,
            },
            position: this.getCenterPoint(polygonArr),
          })
          this.text3.setMap(this.map)
        }
      })
    },
    getCenterPoint(data) {
      var lng = 0.0,
        lat = 0.0
      for (var i = 0; i < data.length; i++) {
        // if ($.isEmptyObject(data[i])) {
        // continue;
        // }
        lng = lng + parseFloat(data[i]["lng"])
        lat = lat + parseFloat(data[i]["lat"])
      }
      lng = lng / data.length
      lat = lat / data.length
      return [lng, lat]
    },
    drawArea() {
      for (let i = 0; i < this.areaList.length; i++) {
        // console.log(this.areaList,'2222')
        this.getArea(this.areaList[i].adcode, this.areaList[i].color)
      }
    },
    getArea(name, color) {
      // console.log(name, color)
      const self = this
      var opts = {
        subdistrict: 1, //返回下一级行政区
        extensions: "all",
        showbiz: false, //最后一级返回街道信息
      }
      let district = new AMap.DistrictSearch(opts)

      try {
        self.map.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker()
      district.search(name, (status, result) => {
        if (status == "complete") {
          let bounds = result.districtList[0].boundaries
          self.polygons = []
          for (var i = 0, l = bounds.length; i < l; i++) {
            self.polygon = new AMap.Polygon({
              map: self.map,
              strokeWeight: 1,
              strokeColor: "#007CDB",
              fillColor: color,
              fillOpacity: 0.06,
              path: bounds[i],
            })
            self.polygons.push(self.polygon)
          }
          // self.map.setFitView() //地图自适应
        }
      })
    },
    getDistrict(name = "341122", params = null) {
      let self = this
      // return new Promise((resolve, reject) => {
      var opts = {
        subdistrict: 1, //返回下一级行政区
        extensions: "all",
        showbiz: false, //最后一级返回街道信息
      }
      let district = new AMap.DistrictSearch(opts)

      try {
        self.map.remove(self.marker)
      } catch (err) {
        console.log(err)
      }

      self.marker = new AMap.Marker()
      district.search(name, (status, result) => {
        if (status == "complete") {
          let areaList = []
          result.districtList[0].districtList.forEach((item) => {
            // console.log(item, "下次code")
            areaList.push({
              adcode: item.adcode,
              name: item.name,
            })
          })
          // areaList[0].color = "#24609C"
          // areaList[1].color = "#467399"
          // areaList[2].color = "#0C2FA0"
          // areaList[3].color = "#3769A6"
          // areaList[4].color = "#22598D"
          // areaList[5].color = "#326A9D"
          // areaList[6].color = "#0C2FA0"
          // areaList[7].color = "#2568A2"
          // areaList[8].color = "#134CA2"
          // areaList[9].color = "#183B77"
          // areaList[10].color = "#183B70"
          // areaList[11].color = "#183B70"

          self.areaList = areaList
          self.drawArea()
        }
      })
    },
  },
  activated() {
    let self = this
  },
  beforeDestory() {},
}
</script>

<style lang="less" scoped>
.main {
  overflow-x: hidden;
  width: 100%;
  .mymap {
    width: 100%;
    height: 100vh;
  }
  #olderJoin {
    width: 100%;
    height: 30vh;
  }
  .oldBox {
    border: 1px solid rgba(34, 236, 255, 1);
    background: #01117b;
    margin-top: 28px;
    position: relative;
    min-height: 35px;
    .leftTitle {
      position: absolute;
      width: 100%;
      height: 35px;
      background: url("./assets/big/titleLeft.png") no-repeat center;
      text-align: center;
      font-size: 17px;
      line-height: 35px;
      color: #22f7ff;
      top: -17px;
    }
    .housexz {
      position: relative;
      top: 10px;
      background-size: 100%;
      padding: 0 10px;
      width: 50%;
      height: 50%;
      text-align: center;
    }
    .workInfo {
      position: relative;
      top: 10px;
      background-size: 100%;
      width: 105px;
      height: 105px;
      text-align: center;
    }
  }
  .realLeft {
    position: absolute;
    top: 100px;
    left: 20px;
    width: 400px;
    height: 300px;
    z-index: 100;
    #totalHouse {
      width: 100%;
      height: 28vh;
    }
    #currentSituation,
    #currentBulidingArea,
    #bedNums {
      width: 100%;
      height: 26vh;
    }
    .leftTitle {
      background-size: 100%;
      width: 80%;
      left: 25px;
    }
  }
  .realRight {
    position: absolute;
    top: 100px;
    right: 20px;
    width: 700px;
    height: 300px;
    z-index: 100;
  }
}
.smallt {
  color: #6ebcff;
}
.newSty {
  display: flex;
  justify-content: space-between;
  margin: 15px 10% 0;
  width: 80%;
  span {
    display: inline-block;
    font-size: 12px;
    color: #fff;
  }
  /deep/.el-progress {
    flex: 1;
    width: 60%;
    margin: 0 8px;
  }
}

.activeList {
  color: #fff;
  flex: 1;
  margin-left: 20px;
  text-align: center;
  font-size: 14px;
  height: 30vh;
  overflow: scroll;
}
.houseContent {
  overflow: hidden;
  margin-top: 10px;
  height: 63vh;
  .houseItem {
    line-height: 25px;
    font-size: 13px;
    color: #e4e4e4;
    display: flex;
    text-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.05);
    margin-top: 25px;
  }
  .flexs {
    display: flex;
    p {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.ac-title {
  color: #1a46f7;
  font-size: 16px;
  padding: 5px 10px 15px 10px;
  border-bottom: 2px solid #0f5bf5;
  position: relative;
  z-index: 99;
  background: #01117b;
}
.ac-item {
  padding: 15px 10px;
  border-bottom: 1px solid #0f5bf5;
  font-size: 13px;
  cursor: pointer;
}
.perInfoBox2 {
  background: rgba(7, 17, 27, 0.5);
  position: fixed;
  width: 100%;
  top: 0%;
  bottom: 0;
  z-index: 999;
}
.close-info2 {
  color: #22f7ff;
  position: absolute;
  top: 20px;
  right: 40px;
  font-size: 30px;
  cursor: pointer;
}
.info-txt2 {
  position: relative;
  color: #fff;
  width: 60%;
  font-size: 14px;
  overflow: scroll;
  margin: 10px auto;
  background: rgba(10, 88, 160, 1);
  margin-top: 8%;
}
.info-item2 {
  border-bottom: 1px solid #085e98;
  padding: 20px 30px;
  line-height: 40px;
  height: 442px;
  // height: 300PX;
}
.intitle2 {
  color: #22f7ff;
  font-size: 18px;
  padding-left: 10px;
}
.defaultImg {
  width: 160px;
  height: 160px;
}
.close-info {
  color: #ffffff;
  position: absolute;
  top: 0px;
  right: 20px;
  font-size: 30px;
  cursor: pointer;
  z-index: 1001000;
}
.info-txt3 {
  position: relative;
  color: #fff;
  width: 50%;
  font-size: 14px;
  // overflow: scroll;
  margin: 10px auto;
  background: rgba(10, 88, 160, 0.8);
}
.intitle {
  color: #ffffff;
  font-size: 20px;
  font-weight: 200;
  margin-bottom: 20px;
  height: 30px;
  line-height: 30px;
}
</style>
